module.exports = __webpack_public_path__ + "static/media/Arrow-default.f3043d66.svg";